<mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
    <mat-select
        [placeholder]="placeholder()"
        [multiple]="multiple()"
        [value]="multiple() ? values() : value()"
        [compareWith]="compareValues"
        [panelWidth]="panelWidth()"
        [disableOptionCentering]="true"
        [panelClass]="panelClass()"
        (selectionChange)="select($event.value)"
        (openedChange)="handleOpenedChange($event)">
        <mat-select-trigger>
            @if (multiple()) {
                {{ triggerLabels }}
            } @else {
                @if (selectedOption(); as selected) {
                    @if (optionTemplate(); as template) {
                        <ng-container *ngTemplateOutlet="template; context: { $implicit: selected }" />
                    } @else {
                        {{ selected.label }}
                    }
                }
            }
        </mat-select-trigger>

        <div
            class="valben-select-search sticky top-0 z-20 flex h-12 items-center border-b px-3"
            (click)="$event.stopPropagation()"
            (keydown)="handleSearchKeydown($event)">
            <mat-icon class="mr-2 text-gray-500">search</mat-icon>
            <input
                #searchInput
                type="text"
                autocomplete="off"
                class="min-w-0 flex-1 border-0 bg-transparent outline-none"
                [attr.aria-label]="searchPlaceholder()"
                [placeholder]="searchPlaceholder()"
                [value]="search()"
                (input)="updateSearch($event)" />
            @if (search()) {
                <button type="button" mat-icon-button aria-label="Očisti pretragu" (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                </button>
            }
        </div>

        @if (virtualScroll()) {
            <cdk-virtual-scroll-viewport
                [itemSize]="virtualItemSize()"
                [minBufferPx]="virtualMinBuffer()"
                [maxBufferPx]="virtualMaxBuffer()"
                [style.height.px]="virtualHeight()"
                (scrolledIndexChange)="handleScrolledIndexChange()">
                <mat-option
                    *cdkVirtualFor="let option of filteredOptions(); trackBy: trackOption"
                    [value]="option.value">
                    @if (optionTemplate(); as template) {
                        <ng-container *ngTemplateOutlet="template; context: { $implicit: option }" />
                    } @else {
                        {{ option.label }}
                    }
                </mat-option>
            </cdk-virtual-scroll-viewport>
        } @else {
            @for (option of filteredOptions(); track option.value) {
                <mat-option [value]="option.value">
                    @if (optionTemplate(); as template) {
                        <ng-container *ngTemplateOutlet="template; context: { $implicit: option }" />
                    } @else {
                        {{ option.label }}
                    }
                </mat-option>
            }
        }

        @for (value of offscreenSelected(); track $index) {
            <mat-option style="display: none" [value]="value">
                @if (optionForValue(value); as option) {
                    {{ option.label }}
                }
            </mat-option>
        }

        @if (loading()) {
            <mat-option disabled>
                <div class="flex items-center justify-center py-2 text-valamarblueprimary">
                    <mat-spinner [diameter]="20" />
                </div>
            </mat-option>
        } @else if (filteredOptions().length === 0) {
            <mat-option disabled>{{ noEntriesLabel() }}</mat-option>
        }
    </mat-select>
</mat-form-field>
